<div class="row" [ngClass]="type === LayoutGridType.short ? '' : 'my-2 px-3'">
  <div class="col text-start editToolbar">
    <dx-toolbar>
      <dxi-item location="before" widget="dxButton" locateInMenu="never">
        <div>
          <div class="toolbar-label">
            <b>{{ title }}</b>
          </div>
        </div>
      </dxi-item>
      <dxi-item location="after" locateInMenu="never">
        <div>
          <dx-button
            [visible]="isEditVisible"
            [icon]="'edit'"
            [stylingMode]="'text'"
            [agMergeGuard]="agentDbId"
            (agMergeGuardedClick)="clickEdit.emit(true)"
          ></dx-button>
        </div>
      </dxi-item>
    </dx-toolbar>
  </div>
</div>
